import { UI } from '../UI';
import { appConfig as $config } from '../../app.config';
import { App } from '../App';

export const ApprovalRejection = (function () {
  const mapping = {
    userGroups: (data) => {
      return data.filter((item) => item.title !== 'Default');
    }
  };

  const dialogButtons = {
    approve: (data) => {
      return {
        label: $lang.btn.approve,
        className: 'btn btn-success btn-approvalrejection-approve auto-test-approve-button',
        callback: function () {
          return submit(data);
        }
      };
    },
    switchReject: () => {
      return {
        label: $lang.btn.reject,
        className: 'btn btn-danger btn-approvalrejection-switch auto-test-switch-button',
        callback: rejectSwitch
      };
    },
    reject: (data) => {
      return {
        label: $lang.btn.applyRejection,
        className: 'btn btn-danger btn-approvalrejection-reject d-none',
        callback: function () {
          return submit(data);
        }
      };
    },
    rejectdelete: (data, sendData) => {
      return {
        label: $lang.btn.applyRejection + ' & ' + $lang.blanks.deleteproducts,
        className: 'btn btn-danger',
        callback: function () {
          // Action DeleteMockups - 2; DeleteListings = 3
          return submit(data, { ...sendData, actions: [2, 3] });
        }
      };
    },
    rejectkeep: (data, sendData) => {
      return {
        label: $lang.btn.applyRejection + ' & ' + $lang.blanks.keepproducts,
        className: 'btn btn-warning',
        callback: function () {
          // Action DeleteMockups - 2
          return submit(data, { ...sendData, actions: [2] });
        }
      };
    },
    applayreject: (data, sendData) => {
      return {
        label: $lang.btn.applyRejection,
        className: 'btn btn-danger',
        callback: function () {
          // Action DeleteMockups - 2
          return submit(data, { ...sendData, actions: [2] });
        }
      };
    },
    cancel: () => {
      return {
        label: $lang.btn.cancel,
        className: 'btn btn-link'
      };
    }
  };

  const dialog = ({ items = {}, page = 'prelistings', callback = () => {} }) => {
    if (!Object.keys(items).length) {
      return;
    }

    UI.blockPage();
    $.when(App.ajaxData(`defaults/all-user-groups`, {}))
      .done((res) => {
        let dialogData = {
          items: items,
          userGroups: mapping.userGroups(res.data),
          $lang: $lang,
          requestPage: page,
          callback: callback
        };

        const template = require('./tmpl/dialog.hbs');
        bootbox
          .dialog({
            size: 'large',
            title: $lang.btn.approveReject,
            message: template(dialogData),
            className: 'modal-approvalrejection-form',
            buttons: {
              approve: dialogButtons.approve(dialogData),
              switchReject: dialogButtons.switchReject(),
              reject: dialogButtons.reject(dialogData),
              cancel: dialogButtons.cancel()
            }
          })
          .init(() => {
            $('#ApprovalRejectionModalForm select[name="userGroup"]').select2();
          });
      })
      .always(() => UI.unblockPage());
  };

  const rejectSwitch = () => {
    const form = $('.modal-approvalrejection-form');
    $('.btn-approvalrejection-approve, .btn-approvalrejection-switch, .approval-block', form).hide();
    $('.btn-approvalrejection-reject, .rejection-block', form).removeClass('d-none');
    $('input[name="rejection"]', form).val(1);
    return false;
  };

  const submit = (data, sendData = null) => {
    if (!sendData) {
      const form = $('#ApprovalRejectionModalForm');
      const formData = form.length ? form.serializeObject() : null;
      // Selected User Group
      let selectedGroup = data.userGroups.filter((group) => group.id === formData.userGroup);

      sendData = {
        approveType: formData.rejection === '1' ? $config.approveType.disapproved : $config.approveType.approved,
        ids: data.items,
        userGroup: selectedGroup.length ? selectedGroup[0] : null,
        comment: formData.comments || null,
        requestPage: data.requestPage
      };
    }

    UI.blockPage();
    $.when(App.ajaxData(`${data.requestPage}/bulk-approve`, sendData, 'PUT'))
      .done((res) => {
        if (res.isSuccess) {
          data.callback(res?.createdObject);
        } else {
          const errData = res.errorInformation?.errorData?.data;
          if (!errData) {
            return data.callback();
          }

          errorHandler(data, sendData, errData);
        }
      })
      .always(() => UI.unblockPage());
  };

  const errorHandler = (data, sendData, errData) => {
    let dialogBtns = {};
    if (errData.listingsCount > 0) {
      dialogBtns = {
        rejectdelete: dialogButtons.rejectdelete(data, sendData),
        rejectkeep: dialogButtons.rejectkeep(data, sendData),
        cancel: dialogButtons.cancel(data, sendData)
      };
    } else if (errData.mockupsCount > 0) {
      dialogBtns = {
        applayreject: dialogButtons.applayreject(data, sendData),
        cancel: dialogButtons.cancel(data, sendData)
      };
    }

    const dialogData = {
      $lang: $lang,
      data: errData
    };

    const template = require('./tmpl/confirm.hbs');
    bootbox.dialog({
      size: 'large',
      title: $lang.approval.Assetrejection,
      message: template(dialogData),
      className: 'modal-danger',
      buttons: dialogBtns
    });
  };

  return {
    dialog,
  };
})();
